import React from "react";
import styled from "styled-components";
import { DashboardCard } from "../../../styles/components/ProStudentDashboard/styles";
import {
  glassMedium,
  glassHover,
} from "../../../styles/components/common/glassmorphism";

const ViewContainer = styled.div`
  ${glassMedium}
  border-radius: 12px;
  padding: 1rem;
  margin-bottom: 1rem;
  transition: all 0.3s ease;

  &:hover {
    ${glassHover}
    transform: translateY(-2px);
  }
`;

const ViewHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
  gap: 1rem;
`;

const CompanyInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

const CompanyLogo = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 8px;
  object-fit: cover;
  background: rgba(255, 255, 255, 0.1);
`;

const CompanyName = styled.h4`
  margin: 0;
  color: rgba(255, 255, 255, 0.95);
  font-size: 1rem;
`;

const ViewDate = styled.span`
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.85rem;
  white-space: nowrap;
`;

const CompanyDetails = styled.div`
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.9rem;
  margin: 0.5rem 0;
`;

const ViewCount = styled.div`
  display: inline-flex;
  align-items: center;
  padding: 0.25rem 0.75rem;
  background: rgba(99, 102, 241, 0.2);
  border-radius: 20px;
  color: rgba(255, 255, 255, 0.9);
  font-size: 0.85rem;
  margin-top: 0.5rem;

  &:before {
    content: "👁️";
    margin-right: 0.5rem;
  }
`;

// Dummy data for profile views
const mockProfileViews = [
  {
    id: 1,
    companyName: "Tech Solutions Inc.",
    logo: "https://images.unsplash.com/photo-1560179707-f14e90ef3623?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80",
    industry: "Software Development",
    location: "New York, NY",
    viewDate: "2025-05-15",
    viewCount: 3,
  },
  {
    id: 2,
    companyName: "Global Innovations",
    logo: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80",
    industry: "Information Technology",
    location: "San Francisco, CA",
    viewDate: "2025-05-14",
    viewCount: 1,
  },
];

const ProfileViews = () => {
  return (
    <DashboardCard>
      <h3 style={{ marginTop: 0, marginBottom: "1rem" }}>
        Recent Profile Views
      </h3>
      {mockProfileViews.map((view) => (
        <ViewContainer key={view.id}>
          <ViewHeader>
            <CompanyInfo>
              <CompanyLogo src={view.logo} alt={view.companyName} />
              <div>
                <CompanyName>{view.companyName}</CompanyName>
                <CompanyDetails>
                  {view.industry} • {view.location}
                </CompanyDetails>
              </div>
            </CompanyInfo>
            <ViewDate>{new Date(view.viewDate).toLocaleDateString()}</ViewDate>
          </ViewHeader>
          <ViewCount>
            {view.viewCount} view{view.viewCount > 1 ? "s" : ""}
          </ViewCount>
        </ViewContainer>
      ))}
    </DashboardCard>
  );
};

export default ProfileViews;
